import defer from 'lib/defer'

const LOCAL_EVENTS = new window.EventTarget()

const storageBus = {

  subscribe(onChange){
    LOCAL_EVENTS.addEventListener('storage', onChange)
    window.addEventListener('storage', onChange)
    return () => {
      LOCAL_EVENTS.removeEventListener('storage', onChange)
      window.removeEventListener('storage', onChange)
    }
  },

  getItem(storage, key){
    return storage[key]
  },

  setItem(storage, key, newValue){
    const oldValue = storage[key]
    if (newValue === oldValue) return
    if (newValue === undefined || newValue === null) {
      delete storage[key]
    }else{
      storage[key] = newValue
    }
    deferChange(storage, key, oldValue)
  },
}

export default storageBus

const deferredChangesByStorage = new Map()
function deferChange(storage, key, oldValue){
  let deferredChanges = deferredChangesByStorage.get(storage)
  if (!deferredChanges) deferredChangesByStorage.set(storage, deferredChanges = {})
  if (!(key in deferredChanges)) deferredChanges[key] = oldValue
  if (!handleDeferredChangesTimeout)
    handleDeferredChangesTimeout = defer(handleDeferredChanges)
}

let handleDeferredChangesTimeout
function handleDeferredChanges(){
  handleDeferredChangesTimeout = undefined
  for (const storage of [window.sessionStorage, window.localStorage]){
    const deferredChanges = deferredChangesByStorage.get(storage)
    deferredChangesByStorage.delete(storage)
    if (deferredChanges)
      for (const key in deferredChanges)
        dispatchChangeEvent(storage, key, deferredChanges[key])
  }
}

function dispatchChangeEvent(storage, key, oldValue){
  const newValue = storage[key]
  if (newValue === oldValue) return
  const changeEvent = new window.Event('storage')
  Object.assign(changeEvent, {
    storageArea: storage,
    key,
    oldValue,
    newValue,
  })
  LOCAL_EVENTS.dispatchEvent(changeEvent)
}
